module.exports = __webpack_public_path__ + "img/who-we-are.0fb200fb.svg";